import { render } from "./PreviewQuestion.vue?vue&type=template&id=3b4ce517"
import script from "./PreviewQuestion.vue?vue&type=script&lang=ts"
export * from "./PreviewQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script